import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const loopeldConfig: TSPConfig = {
  key: 'loopeld',
  name: 'LoopELD',
  imageName: 'LoopELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API Key from LoopELD support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default loopeldConfig;
